module.exports = __webpack_public_path__ + "img/bank-card.81c43ed3.png";